import React from 'react'
import { Select } from 'antd';

const SelectInput = ({options,placeholder,classname}) => {
  return (
    <div>
      <Select
        showSearch
        placeholder={placeholder}
        filterOption={(input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
        }
        options={options}
        className={classname ? classname :null}
      />
    </div>
  )
}

export default SelectInput
